(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Form = (function(superClass) {
    extend(Form, superClass);

    Form.prototype.setInitialDeps = function() {
      Form.__super__.setInitialDeps.call(this);
      return this.syncDeps({
        'Layer': 'grower::viewmodels/prescription_map/Layer'
      });
    };

    function Form(handler, data, deps) {
      if (data == null) {
        data = {};
      }
      if (deps == null) {
        deps = {};
      }
      Form.__super__.constructor.call(this);
      this.setInitialDeps();
      this.syncDeps(deps);
      this.handler = handler;
      this.editing = ko.observable(false);
      this.layer = ko.observable(new (this.getDep('Layer'))(this, data));
    }

    Form.prototype.setEditing = function() {
      this.editing(true);
      return this.handler.bindForSubmit();
    };

    Form.prototype.getHandler = function() {
      return this.handler;
    };

    return Form;

  })(KoModel);

}).call(this);
